import axios from "../config/axios.v2";
import { META_URL, metaByIdUrl, metaBySlugUrl } from "./meta.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("metaService err::", err);
  throw err;
};

const MetaService = {
  // params: { page, limit, slug }
  getAll: (params) => axios.get(META_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(metaByIdUrl(id)).then(unwrap).catch(handleError),
  getBySlug: (slug) => axios.get(metaBySlugUrl(slug)).then(unwrap).catch(handleError),
  create: (payload) => axios.post(META_URL, payload).then(unwrap).catch(handleError),
  update: (id, payload) => axios.patch(metaByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(metaByIdUrl(id)).then(unwrap).catch(handleError)
};

export default MetaService;
